import { useState, CSSProperties } from 'react';
import styles from './Tabber.module.scss';

export interface TabberProps {
  tabIds: string[];
  getHeader: (tabId: string) => string;
  renderContent: (tabId: string) => JSX.Element | null;
  activeTabId?: string; // Optional prop to set the initially active tab
  titlesSingleLine?: boolean; // Set to true to display tab titles in a single line
  selectionStyle?: 'color' | 'bold'; // Style for the selected tab
  headerStyles?: CSSProperties; // Custom styles for the tabber
}

/**
 * Tabber component allows switching between different tabs.
 * @param tabIds - Array of unique identifiers for each tab
 * @param getHeader - Function to get the header text for each tab based on its ID
 * @param renderContent - Function to render the content for each tab based on its ID
 */
export default function Tabber({
  tabIds,
  getHeader,
  renderContent,
  activeTabId,
  titlesSingleLine = false,
  selectionStyle = 'color',
  headerStyles = {},
}: TabberProps) {
  const [selectedId, setSelectedId] = useState(activeTabId && tabIds.includes(activeTabId) ? activeTabId : tabIds[0]);
  const classNames = `${styles.tabberGroup} ${titlesSingleLine ? styles.tabberGroupSingleLine : ''}`;

  function getTabClassName(tabId: string): string {
    const isSelected = selectedId === tabId;
    const mainClass = isSelected ? styles.tabberItemActive : styles.tabberItem;
    const modusClass = selectionStyle === 'bold' ? styles.boldSelection : '';
    return `${mainClass} ${modusClass}`;
  }

  return (
    <>
      {tabIds.length > 1 && (
        <div className={classNames} style={{ ...headerStyles }}>
          {tabIds.map((tabId) => (
            <div key={tabId} className={getTabClassName(tabId)} onClick={() => setSelectedId(tabId)}>
              {getHeader(tabId)}
            </div>
          ))}
        </div>
      )}
      <div key={selectedId}>{renderContent(selectedId)}</div>
    </>
  );
}
